<template>
  <app-layout>
    <div class="gifts-confirmation-page">
      <v-overlay color="primary" opacity="0.7" :value="loading">
        <v-progress-circular
          indeterminate
          color="secondary"
          size="85"
          width="8"
        ></v-progress-circular>
      </v-overlay>
      <section
        class="confirmation-details-section page-section bg-white mx-auto"
      >
        <div class="container mx-auto flex flex-col items-center">
          <h1 class="heading-1 text-center">{{ $t('gifts.purchase_confirmed') }}</h1>
          <p class="sub-headline text-center mt-3 mb-10">
            {{ $t('gifts.weve_sent_you_an_email') }}
          </p>
          <div class="card-confirmation w-full" v-if="!loading">
            <div class="img-container overflow-hidden">
              <img src="/img/card-blog.jpg" alt="" />
            </div>
            <div class="px-5 py-6 flex flex-col items-center">
              <div class="flex justify-center mt-2 mb-6">
                <div
                  class="details-icon-text-container flex flex-col md:flex-row grow-0 w-1/3 md:w-auto"
                >
                  <img class="md:mr-3" src="/img/icons/airplane.svg" />
                  <p class="text-details font-bold text-center">
                    {{ $t('shared.from') }} {{ gift.origin }}
                  </p>
                </div>
                <div
                  class="details-icon-text-container flex flex-col md:flex-row grow-0 w-1/3 md:w-auto"
                >
                  <img class="md:mr-3" src="/img/icons/user.svg" />
                  <p class="text-details font-bold text-center">
                    {{ gift.passengers }}
                    {{ $tc('shared.adult', gift.passengers) }}
                  </p>
                </div>
                <div
                  class="details-icon-text-container flex flex-col md:flex-row grow-0 w-1/3 md:w-auto"
                >
                  <img class="md:mr-3" src="/img/icons/location.svg" />
                  <p class="text-details font-bold text-center">
                    {{ $t('shared.destiny') }} {{ gift.destination }}
                  </p>
                </div>
              </div>
              <p class="mb-8 text-center">
                {{ $t('gifts.youll_receive_an_email') }}
              </p>
              <div class="code flex items-center px-5">
                <p class="font-bold flex flex-col items-center sm:flex-row">
                  {{ $t('gifts.gift_code') }}:<span class="hidden sm:inline">&nbsp;</span
                  ><span>{{ gift.code }}</span>
                </p>
              </div>
              <redsys-data-component v-if="redsysParams" :redsysData="redsysParams"></redsys-data-component>
              <div class="price md:self-end mr-3 mt-6 font-bold">
                {{ $t('gifts.total_amount') }}: <span>{{ gift.price | currency }}</span>
              </div>
            </div>
          </div>
        </div>
      </section>
      <app-banner-blog v-if="gift != null" :destination="gift.destination_code"></app-banner-blog>
      <section
        class="page-section bg-white"
        data-section-name="favorite-destinies"
      >
        <div class="container mx-auto">
          <h2 class="heading-2 color-black text-center">{{ $t('shared.inspire_yourself') }}</h2>
          <p class="paragraph-h-18 color-black text-center">
            <!-- Lorem ipsum dolor sit amet, consectetur adipiscing elit. -->
          </p>
          <v-row class="grid-cards hidden lg:flex">
            <v-col
              v-for="(destiny, index) in destinies"
              :key="index"
              :sm="1"
              :md="4"
              class="p-4"
              >
              <app-card-destiny-bg
                :image="destiny.home_thumbnail_image"
                :title="destiny.name"
                :price="destiny.pivot.base_price"
                :route="destiny.code"
              ></app-card-destiny-bg>
            </v-col>
          </v-row>
          <app-destinies-carousel
            class="lg:hidden xl:hidden"
            :slides="favoriteDestinies"
          ></app-destinies-carousel>
          <v-btn
            rounded
            elevation="0"
            color="secondary"
            class="avm-btn avm-btn--large mx-auto block"
            @click.stop="navigateToDestinies()"
          >
            {{ $t('shared.discover_destinations') }}
          </v-btn>
        </div>
      </section>
      <app-banner-gift></app-banner-gift>
      <app-banner-newsletter class="bg-palegray"></app-banner-newsletter>
    </div>
  </app-layout>
</template>

<script lang="ts">
import axios from "axios";
import {
  GIFTS_GET_SELECTED_DESTINATION,
} from "../../store/gifts/getter-types";
import { RESET_GIFTS_STATE, SET_GIFTS_STATE } from "../../store/gifts/mutation-types";
import { SET_TERMS } from '../../store/booking/mutation-types';

export default {
  data: function () {
    return {
      gift: null,
      loading: true,
      favoriteDestinies: [],
      destinies: []
    };
  },
  computed: {
    destination() {
      return this.$store.getters[GIFTS_GET_SELECTED_DESTINATION];
    },
    redsysParams() {
      return this.$route.query.redsys && JSON.parse(this.$route.query.redsys) || null;
    }
  },
  methods: {
    goToStep(stepNumber) {
      this.activeStep = stepNumber;
    },
    handleStepComplete: function () {
      this.activeStep = this.activeStep === 4 ? 1 : this.activeStep + 1;
    },
    navigateToDestinies() {
      this.$router.push({ name: "destinies-results" });
    },
  },
  async created() {
    const { data } = await axios.get("/api/locations");
    this.destinies = data
      .flatMap((location) => location.destinations)
      .filter((destination) => destination.pivot.visible && destination.order)
      .filter((destination, index, arr) => {
        return arr.findIndex((d) => d.id === destination.id) === index;
      })
      .sort((a, b) => (a.order > b.order ? 1 : -1))
      .slice(0, 6);


    axios
      .get(`/api/gifts/${this.$route.params.code}/retrieve`)
      .then(({ data }) => {
        this.gift = data;
        this.$store.commit(SET_GIFTS_STATE, [
          { prop: "origin_id", value: data.origin_id },
          { prop: "destination_id", value: data.destination_id },
        ]);
        this.loading = false;
      })
      .catch((e) => this.$router.push({ name: "404" }));
  },
  beforeDestroy() {
    this.$store.commit(RESET_GIFTS_STATE);
    this.$store.commit(SET_TERMS, {
      promotions: { error: false, value: false },
      terms: { error: false, value: false }
    });
  }
};
</script>

<style lang="scss" scoped>
/* @import "../../sass/variables"; */
.sub-headline {
  /* font-family: $avenirHeavy; */
  font-size: 16px;
}
.page-booking-confirmation {
  .page-section {
    padding: 6.25rem 0;
    .grid-cards {
      margin: 2.5rem 0 3rem;
    }
  }
}
.v-overlay {
  position: fixed;
}
</style>
